'use client';

import { Input } from '@apex-titan/ui';
import { type ComponentProps } from 'react';
import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from 'react-hook-form';

type FormInputProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<
    ComponentProps<typeof Input>,
    'value' | 'onChange' | 'name' | 'defaultValue'
  >;

export function FormInput<T extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  shouldUnregister,
  ...inputProps
}: FormInputProps<T>) {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });
  return (
    <Input
      {...inputProps}
      {...field}
      value={field.value ?? ''}
      errorMessage={fieldState.error?.message}
    />
  );
}
